<template>
  <div>
    <v-list flat dense>
      <draggable v-model="operators" @start="startTouch" @end="endTouch" handle=".draggable-area" ghost-class="ghost" ref="draggableComponent">
        <div v-for="(operator) in operators" v-bind:key="operator.id">
          <v-list-item>
            <v-list-item-avatar>
              <v-icon small class="draggable-area mx-2 mr-4">mdi-menu</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <div>
                <v-container v-if="!editing || editOperator.id != operator.id" fluid class="pa-0">
                  <v-row class="ma-0 pa-0">
                    <v-col class="pa-0">
                      {{operator.firstname + ' ' + operator.lastname}}
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </div>
      </draggable>
    </v-list>

  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DurationPicker from '@/components/common/DurationPicker.vue'
import StandardDialog from '@/components/common/StandardDialog.vue'
import dateUtils from '@/mixins/common/dateUtils.js'
import operatorsService from '@/services/operators/operators.service';

export default {
  name: "OrderOperatorForm",
  mixins: [dateUtils],
  components: {
    draggable,
    DurationPicker,
    StandardDialog
  },
  data: function() {
    return {
      operators: [],
      drag: false,
      editOperator: undefined,
      createService: {},
      newServiceDialog: false,
      editValid: false,
      createValid: false,
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
      oldOperators: undefined
    }
  },
  props: {
    generateIdWhenCreate: {
      type: Boolean,
      default: false
    },
    bus:{
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: async function() {
    this.bus.$on('changeOrder', this.changeOrder)
    this.bus.$on('closeOrder', this.closeOrder)

    this.operators = await operatorsService.cachedList({filters: { notInStateOperator: 'disabled' }})
    
    let counter = 0
    this.operators.forEach(elem => {
      elem.order = counter
      counter++
    })
    this.oldOperators = this.operators
  },
  methods: {
    edit(operator) {
      this.editOperator = {...operator}
    },
    submitCreate() {
      if(!this.createService.minutes){
        alert('Inserire una durata')
      } else {
      if(this.generateIdWhenCreate) {
        let id = this.getUniqId()
        this.operators.push({id: id, ...this.createService})
      } else {
        this.operators.push({...this.createService})
      }

      this.$emit('create-phase', this.createService)
      this.newServiceDialog = false
      this.createService = {}
      this.$refs.newForm.resetValidation()
      this.$emit('input', this.operators)
      }
    },
    submitEdit() {
      let index;
      for(var i = 0; i < this.operators.length; i++) {
        if(this.operators[i].id == this.editOperator.id) {
          index = i
        }
      }
      if(index != undefined) {
        this.operators[index] = Object.assign({}, this.operators[index], this.editOperator)
        this.$emit('update-phase', this.editOperator)
        this.$emit('input', this.operators)
      }
      this.editOperator = undefined
    },
    getUniqId() {
      let max = 0;
      for(let i = 0; i < this.operators.length; i++) {
        if(max == undefined || parseInt(this.operators[i].id) > max) {
          max = parseInt(this.operators[i].id)
        }
      }
      return max + 1
    },
    startTouch() {
      this.drag = true
    },
    endTouch(context) {
      this.drag = false
    },
    async changeOrder(){
      let counter = 0
      this.operators.forEach(elem => {
        elem.order = counter
        counter++
      })
      
      this.oldOperators = this.operators

      let mapped = this.operators.map(elem => {return {id: elem.id, order: elem.order}})
      await operatorsService.updateOrderOperators(mapped)
      this.bus.$emit('fetchOrder')
    },
    closeOrder(){
      this.operators = this.oldOperators
    }
  },
  computed: {
    editing() {
      return !!this.editOperator
    }
  },
  watch: {
    value(newValue) {
      this.operators = newValue
    }
  }
}
</script>

<style>

.draggable-area {
	cursor: move
}

.ghost {
	background-color: #b6b6b6;
	opacity: 0.2;
}

</style>